module.exports = __webpack_public_path__ + "images/tiny-loading-f6edaca97863c4013db4dd8b28763d3b.gif";